import { Stack } from "@mui/system";
import { ReuseInput } from "../../ReuseInput";
import { CustomButton } from "../../CustomButton";
import { TrashIcon } from "../../../images";

export const SubCidItem = ({
  subCid,
  isDisabled,
  onChange,
  onDelete,
}: {
  subCid: string;
  isDisabled?: boolean;
  onChange: (subCid: string) => void;
  onDelete: () => void;
}) => {
  return (
    <Stack gap={"32px"}>
      <Stack flexDirection={"row"} maxWidth={"480px"} gap={"8px"}>
        <ReuseInput
          isDisabled={isDisabled}
          name="company_name"
          handleInputChange={(field, value) => onChange(value)}
          errorMessage={
            "Must contain only letters, numbers, and basic punctuation"
          }
          value={subCid}
          label="Sub-CID (Optional)"
          placeholder="АА12345-1"
          isError={false}
          setErrorHandler={() => {}}
        />
        <CustomButton
          disabled={isDisabled}
          onClick={onDelete}
          variant="outlined"
          customColor=""
          customSize="s"
          sx={{
            minWidth: "auto",
            p: 1,
            width: "42px",
            height: "42px",
            border: "none",
            "&:hover": {
              backgroundColor: "rgba(28, 60, 108, 0.08)",
            },
            "&.Mui-disabled": {
              border: "none",
            },
          }}
        >
          <TrashIcon color="#4C545B" opacity={isDisabled ? "0.6" : "1"} />
        </CustomButton>
      </Stack>
    </Stack>
  );
};
